import ErrorMessage from '../formFields/ErrorMessage';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export default function AuthEmailField({
  errors,
  id,
  name,
}: {
  errors: string[] | undefined;
  id: string;
  name: string;
}) {
  return (
    <div className="flex w-full flex-col items-start justify-center">
      <Label htmlFor={id} className="sr-only">
        Your Email
      </Label>
      <Input type="email" placeholder="Enter your email address" name={name} className="mb-4 w-full" id={id} />
      {errors?.map((error) => <ErrorMessage className="my-0 mb-4 w-full" key={error} error={error} />)}
    </div>
  );
}
